/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { adminLogin } from "../state/actions/authActions";
import axios from "axios";
import { apiKey } from "../config/config";

function LoginPage() {
  // const dispatch = useDispatch();
  // const auth = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showpassword, setShowPassword] = useState(false)
  const [error, setError] = useState(false);

  const navigate = useNavigate();

  // const handleLogin = () => {
  //   dispatch(adminLogin(email, password));
  // };

  const handleLogin = () => {
    try {
      axios
        .post(apiKey + "/login-dealer", {
          email,
          password,
        })
        .then((res) => {
          if (res.data.dealer.status == 1) {
            sessionStorage.setItem(
              "aman-admin",
              JSON.stringify({
                // token: res.data.accessToken,
                admin: JSON.stringify(res.data.dealer),
              })
            );
            if (res.data.dealer.light_mode === "yes") {
              console.log(res.data.dealer.light_mode);
              navigate("/lightmode/dashboard");
            } else {
              navigate("/dashboard");
            }
          } else {
            setError("This account has been deactivated.");
          }
        })
        .catch((err) => {
          console.error(err);
          setError("Invalid Credentials Or Some other error");
        });
    } catch (err) {
      console.error(err);
      setError("Some Error Occured");
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem("aman-admin")) {
      try {
        if (
          JSON.parse(
            JSON.parse(sessionStorage.getItem("aman-admin") || "")?.admin || ""
          )?.light_mode === "yes"
        ) {
          navigate("/lightmode/dashboard");
        } else {
          navigate("/dashboard");
        }
      } catch {
        navigate("/dashboard");
      }
    }
  });
  return (
    <div className="container-fluid w-100">
      <div className="row login-main">
        <div className="left-container d-none d-md-block col-lg-6 col-md-12 d-flex justify-content-center align-items-center py-5 h-100 bg-[#F0F3F7]">
          <div className="text-center">
            <img src="/img/background.png" alt="" className="img-fluid" />
            <h1 className="loginh1">أمان القروض</h1>
            <p className="loginp">
              البرنامج الوحيد بالمملكة الذي يوفر لك الأمان ويساعدك في كشف
              العملاء المتلاعبين ومن لديهم تعثر في السداد، ويدير مكتبك بطريقة
              إلكترونية في أي وقت ومن أي مكان.
            </p>
            <img src="/img/loading.png" alt="" className="img-fluid loaderlogin" />
          </div>
        </div>
        <div className="col-lg-6 col-md-12 py-5">
          <div className="right-container d-flex flex-column justify-content-center align-items-center h-100">
            <div className="text-center">
              <img src="/img/logo.png" alt="logo" />
              <h1 className="">Welcome Back</h1>
              <p className="">Please login to access your account</p>
            </div>

            <form
              className="col-8"
              onSubmit={(e) => {
                e.preventDefault();
                handleLogin();
              }}
            >
              <div className="">
                <label>E-mail</label>
                <input
                  type="text"
                  name=""
                  className="form-control"
                  placeholder="Email"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="">
                <label>Password</label>
                <div className="position-relative">
                  <input
                    type={showpassword ? "text" : "password"}
                    name=""
                    className="form-control"
                    placeholder="Type your password"
                    onChange={(e) => setPassword(e.target.value)}
                    style={{ paddingRight: "40px" }}
                  />
                  <span
                    onClick={() => setShowPassword(!showpassword)}
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                      zIndex: 10
                    }}
                  >
                    <i className={showpassword ? "fa-regular fa-eye-slash" : "fa-regular fa-eye"}></i>
                  </span>
                </div>
                <p 
                  className="mt-2 text-primary" 
                  style={{ cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }} 
                  onClick={() => navigate("/forgot-password")}
                >
                  Forgot Password?
                </p>
              </div>

              <div className="">
                <button className="btn btn-primary w-100"> Submit </button>
                {/* {auth.error && <p>{auth.error}</p>} */}
                <p className="account mt-2">Don't have an account? Register</p>
              </div>
              {error && (
                <p className="bg-danger text-white text-center">{error}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
